import { makeStyles } from '@material-ui/styles';
import { Box, createStyles, Theme, Typography } from '@material-ui/core';
import Image from 'next/image';
import { associationLogo10, associationLogo12, associationLogo7, associationLogo8 } from '../../images/about-us';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: '3px solid #F36C21',
      borderRadius: 4,
      backgroundColor: '#fff',
      padding: theme.spacing(4, 2),
      maxWidth: 718,

      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3, 6),
      },
    },

    header: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(2.5),
    },

    line: {
      flex: 1,
      height: 1,
      backgroundColor: theme.palette.grey[400],
    },

    title: {
      padding: '0 15px',
      fontWeight: 500,
      whiteSpace: 'nowrap',
      fontSize: '20px',
      color: theme.palette.common.black,
    },

    logosWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(3),
    },

    logo: {
      maxHeight: 60,
      maxWidth: 160,
      objectFit: 'contain',
      display: 'block',
    },
  }),
);

export const CertifiedMemberBlock = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.line} />

        <Typography className={classes.title}>Certified Member</Typography>

        <Box className={classes.line} />
      </Box>

      <Box className={classes.logosWrapper}>
        <Image src={associationLogo8} alt="NATE" className={classes.logo} width={112} height={70} />
        <Image src={associationLogo10} alt="Avetta" className={classes.logo} width={112} height={70} />
        <Image src={associationLogo7} alt="ISN" className={classes.logo} width={112} height={70} />
        <Image src={associationLogo12} alt="Smart Electric Power Alliance" className={classes.logo} width={112} height={70} />
      </Box>
    </Box>
  );
};
